import React from 'react';
import axios from 'axios';

export function getUserCredits() {
  return axios.get('/api/credits/user.json').then((response) => response.data);
}